import {TableBody} from './TableBody';
import {RenderTable} from './RenderTable';
import {TableColumn} from './TableColumn';
import {TableHeader} from './TableHeader';
import {TableRow} from './TableRow';
import {TableTd} from './TableTd';
import {TableFoot} from './TableFoot';

export const Table = {
    Root: RenderTable,
    Column: TableColumn,
    Header: TableHeader,
    Row: TableRow,
    Body: TableBody,
    Td: TableTd,
    tfoot: TableFoot
}